<template>
  <div class="w-100">
    Multiple quotes notification for
    <job-object :job-number="activity.job_id" />

    emailed to CCT

    <message-object :tooltip="messageContent()" />
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
